import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

const Wrapper = styled.section`
  position: relative;
  // margin-top: 90px;
  min-height: 300px;
`
const BgImg = styled(Img)`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  min-height: 600px;
  max-height: 100vh;
  @media (min-width: ${props => props.theme.responsive.small}) {
    height: ${props => props.height || 'auto'};
  }
  & img {
    // max-height: 80vh;
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || 'center center'} !important;
  }

 /* @media screen and (max-width: 600px) {
    background: url(Embello-Mobile-1.jpg) no-repeat;
    height: 20px;
  } */

  &::before {
    content: '';

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

const ResponsiveHero = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  min-height: 552px;
  height: auto;
  @media (min-width: ${props => props.theme.responsive.small}) {
    height: ${props => props.height || 'auto'};
  }
  & > img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
  }

  @media screen and (min-width: 717px) {
    & > .hero-small {
      display: none;
    }
    & > .hero-image {
      display: block;
    }
  }

  @media screen and (max-width: 717px) {
    & > .hero-small {
      display: block;
    }

    & > .hero-image {
      display: none;
    }
  }

  &::before {
    content: '';

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

const Title = styled.h1`
  position: absolute;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  padding-top: 90px;
  top: 0.5em;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Prompt;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  font-size: 34px;
  text-align: center;
  letter-spacing: 0.177083px;
  color: ${props => props.theme.colors.secondary};
  @media screen and (max-width: 600px) {
    line-height: 25px;
    font-size: 18px;
    letter-spacing: 0.43px;
  }
`

const Subtitle = styled.h1`
  position: absolute;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  padding-top: 90px;
  padding-left: 15px;
  padding-right: 15px;
  top: 2em;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Cormorant;
  font-style: normal;
  font-weight: normal;
  line-height: 29px;
  font-size: 28px;
  text-align: center;
  letter-spacing: 0.78px;
  color: ${props => props.theme.colors.secondary};
  margin-top: 5px;
  @media screen and (max-width: 600px) {
    line-height: 23px;
    font-size: 18px;
    text-align: center;
    letter-spacing: 0.557143px;
  }
`

const Footer = styled.div`
  position: absolute;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding-right: 20px;
  padding-bottom: 15px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  font-size: 16px;
  letter-spacing: 0.430833px;
  text-align: right;
  color: ${props => (props.isBlue ? '#000000' : '#FFFFFF')};
  a {
    color: ${props => (props.isBlue ? '#000000' : '#FFFFFF')};
  }

  @media screen and (max-width: 600px) {
    font-family: Raleway;
    font-style: normal;
    font-weight: 300;
    line-height: 16px;
    font-size: 12px;
    text-align: right;
    letter-spacing: 0.409091px;
    padding: 5px 10px;
  }
`

const Hero = props => {
  let imagePhoto = ''
  let responsivePhoto = '';
  
  if (props.image != null && (props.image.fixed || props.image.fluid)) {
    imagePhoto = <BgImg 
      position={props.position || false}
      height={props.height} fluid={ props.fixed ? props.image.fixed : props.image.fluid } 
    />
  }
  if (
    props.responsiveImage != null && (props.responsiveImage.fixed || props.responsiveImage.fluid) &&
    props.image != null && (props.image.fixed || props.image.fluid)) {
    responsivePhoto = 
      <ResponsiveHero>
        <BgImg className='hero-image' height={props.height} 
          position={props.position || false}
          fluid={ props.fixed ? props.image.fixed : props.image.fluid }  />
        <BgImg 
          position={props.position || false}
          className='hero-small' height={props.height} 
          fluid={ props.fixed ? props.responsiveImage.fixed : props.responsiveImage.fluid }  />
      </ResponsiveHero>
  }

  return (
    <Wrapper>
      {props.responsive ? 
        responsivePhoto
      :
        imagePhoto}
      <Subtitle>{props.subtitle}</Subtitle>
      <Footer
        style={{
          color: props.isBlue ? '#000000' : '#FFFFFF',
          a: props.isBlue ? '#000000' : '#FFFFFF',
        }}
        isBlue={props.isBlue}
        dangerouslySetInnerHTML={{
          __html:
          props.footer.childMarkdownRemark != null
          ? props.footer.childMarkdownRemark.html
          : '',
        }}
        />
    </Wrapper>
  )
}

export default Hero
